import { Link, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, PlusCircle, LogOut, ShieldCheck, Package, MessageCircle, Hammer, Layers, Banknote, ShoppingBag, Wrench } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import BrandMark from "@/components/BrandMark";

export default function RetailerLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const isAdmin = user?.role === "admin";

  function doLogout() {
    logout();
    nav("/");
  }

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="retailer-shell">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <BrandMark className="w-16 h-16 sm:w-20 sm:h-20" />
            <span className="hidden sm:inline text-xs text-slate-500 border border-slate-200 rounded px-1.5 py-0.5 ml-1">
              {isAdmin ? "Admin" : "Retailer"}
            </span>
          </Link>
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline text-sm text-slate-600">{user?.name || user?.email}</span>
            <button
              onClick={doLogout}
              className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-[#E05915] transition-colors"
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4" aria-hidden="true" /> Sign out
            </button>
          </div>
        </div>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center gap-1 pb-2 -mt-1 no-scrollbar overflow-x-auto">
          {isAdmin ? (
            <>
              <NavItem to="/admin" end icon={<ShieldCheck className="w-4 h-4" />} label="Overview" testId="nav-admin" />
              <NavItem to="/admin/fitters" icon={<Hammer className="w-4 h-4" />} label="Fitters" testId="nav-admin-fitters" />
              <NavItem to="/admin/opportunities" icon={<Wrench className="w-4 h-4" />} label="Opportunities" testId="nav-admin-opportunities" />
              <NavItem to="/admin/projects" icon={<Layers className="w-4 h-4" />} label="Projects" testId="nav-admin-projects" />
              <NavItem to="/admin/orders" icon={<ShoppingBag className="w-4 h-4" />} label="Orders" testId="nav-admin-orders" />
            </>
          ) : (
            <>
              <NavItem to="/retailer" end icon={<LayoutDashboard className="w-4 h-4" />} label="Dashboard" testId="nav-dashboard" />
              <NavItem to="/retailer/new" icon={<PlusCircle className="w-4 h-4" />} label="New listing" testId="nav-new-listing" />
              <NavItem to="/retailer/reservations" icon={<Package className="w-4 h-4" />} label="Reservations" testId="nav-reservations" />
              <NavItem to="/retailer/enquiries" icon={<MessageCircle className="w-4 h-4" />} label="Enquiries" testId="nav-enquiries" />
              <NavItem to="/retailer/payouts" icon={<Banknote className="w-4 h-4" />} label="Payouts" testId="nav-payouts" />
            </>
          )}
        </div>
      </header>
      <div className="flex-1">{children}</div>
    </div>
  );
}

function NavItem({ to, icon, label, end, testId }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium whitespace-nowrap shrink-0 transition-colors ${
          isActive
            ? "bg-[#E05915]/10 text-[#E05915]"
            : "text-slate-600 hover:text-slate-900 hover:bg-slate-100"
        }`
      }
      data-testid={testId}
    >
      {icon}
      {label}
    </NavLink>
  );
}
